export default () => {
  const menu = document.getElementById('js-menu');
  menu.addEventListener('click', function(event) {
    event.preventDefault();
    menu.classList.toggle('js-menu-open');
  });

  document.querySelectorAll('.gnav_box li').forEach(function(gnavboxLi) {
    gnavboxLi.addEventListener('click', function(event) {
      menu.classList.remove('js-menu-open');
    });
  });
}
